import BigNumber from 'bignumber.js';

export default function formatTotal(value: string | number | undefined) {
  const total = new BigNumber(value || '');
  if (total.isNaN()) return '0';

  const returnValue = total.toNumber();
  return total.isPositive() ? `+${returnValue}` : returnValue;
}
